// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Finterfaces%2Fsrc%2Fworkflow-model.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { GridRangeFilter, GridRangeSampleFilter, GridSubtreeFilter, SequentialItemFilter } from '../workflow-model.g';
import { asyncBoundaryLoaderTypeValidatorInstance } from '../../generated/validator/iasync-boundary-loader-validator.g';
import { itemDeltaValidatorInstance, itemOperationValidatorInstance, schemaObjectHeaderValidatorInstance, sourceInfoValidatorInstance } from '@augloop/types-core';
import { workflowModelItemSchemaValidatorInstance } from '../../generated/validator/workflow-model-schema-validator.g';
import { validateArray } from '@augloop/validator-common';
export class WorkflowModelOptionsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowModelOptions: Expected object, got undefined object for WorkflowModelOptionsValidator' };
        }
        if ((obj.includeItemOperations !== undefined) && (typeof obj.includeItemOperations !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "includeItemOperations" is wrong type' };
        }
        if ((obj.includeExistingAnnotations !== undefined) && (typeof obj.includeExistingAnnotations !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "includeExistingAnnotations" is wrong type' };
        }
        if ((obj.includeDefaultItemDeltas !== undefined) && (typeof obj.includeDefaultItemDeltas !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "includeDefaultItemDeltas" is wrong type' };
        }
        if ((obj.includeScopeItemParent !== undefined) && (typeof obj.includeScopeItemParent !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "includeScopeItemParent" is wrong type' };
        }
        if ((obj.includeRootItemParent !== undefined) && (typeof obj.includeRootItemParent !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "includeRootItemParent" is wrong type' };
        }
        if ((obj.asyncBoundaryLoaderType !== undefined)) {
            const result = asyncBoundaryLoaderTypeValidatorInstance.validate(obj.asyncBoundaryLoaderType);
            if (!result.success) {
                result.error = "WorkflowModelOptions.asyncBoundaryLoaderType: " + result.error;
                return result;
            }
        }
        if ((obj.maxModelItems !== undefined) && (typeof obj.maxModelItems !== 'number')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "maxModelItems" is wrong type' };
        }
        if ((obj.allowStableAnnotationIds !== undefined) && (typeof obj.allowStableAnnotationIds !== 'boolean')) {
            return { success: false, error: 'WorkflowModelOptions: Optional field "allowStableAnnotationIds" is wrong type' };
        }
        return { success: true };
    }
}
export const workflowModelOptionsValidatorInstance = new WorkflowModelOptionsValidator();
export class SequentialItemFilterValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SequentialItemFilter: Expected object, got undefined object for SequentialItemFilterValidator' };
        }
        if ((obj.start !== undefined) && (typeof obj.start !== 'number')) {
            return { success: false, error: 'SequentialItemFilter: Optional field "start" is wrong type' };
        }
        if ((obj.maxCount !== undefined) && (typeof obj.maxCount !== 'number')) {
            return { success: false, error: 'SequentialItemFilter: Optional field "maxCount" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'SequentialItemFilter: Optional field "id" is wrong type' };
        }
        if (obj.ids !== undefined) {
            const result = validateArray(obj.ids, 1, undefined, 'string');
            if (!result.success) {
                result.error = "SequentialItemFilter.ids: " + result.error;
                return result;
            }
        }
        if ((obj.itemType !== undefined) && (typeof obj.itemType !== 'string')) {
            return { success: false, error: 'SequentialItemFilter: Optional field "itemType" is wrong type' };
        }
        if (obj.itemTypes !== undefined) {
            const result = validateArray(obj.itemTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "SequentialItemFilter.itemTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SequentialItemFilter.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SequentialItemFilter"' };
        }
        return { success: true };
    }
}
export const sequentialItemFilterValidatorInstance = new SequentialItemFilterValidator();
export class GridRangeValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridRange: Expected object, got undefined object for GridRangeValidator' };
        }
        if (obj.row === undefined) {
            return { success: false, error: 'GridRange: Required field "row" is missing' };
        }
        else if (typeof obj.row !== 'number') {
            return { success: false, error: 'GridRange: Required field "row" is wrong type' };
        }
        if (obj.col === undefined) {
            return { success: false, error: 'GridRange: Required field "col" is missing' };
        }
        else if (typeof obj.col !== 'number') {
            return { success: false, error: 'GridRange: Required field "col" is wrong type' };
        }
        if (obj.rows === undefined) {
            return { success: false, error: 'GridRange: Required field "rows" is missing' };
        }
        else if (typeof obj.rows !== 'number') {
            return { success: false, error: 'GridRange: Required field "rows" is wrong type' };
        }
        if (obj.cols === undefined) {
            return { success: false, error: 'GridRange: Required field "cols" is missing' };
        }
        else if (typeof obj.cols !== 'number') {
            return { success: false, error: 'GridRange: Required field "cols" is wrong type' };
        }
        return { success: true };
    }
}
export const gridRangeValidatorInstance = new GridRangeValidator();
export class GridSubtreeFilterValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridSubtreeFilter: Expected object, got undefined object for GridSubtreeFilterValidator' };
        }
        if (obj.ranges === undefined) {
            return { success: false, error: 'GridSubtreeFilter: Required field "ranges" is missing' };
        }
        else {
            const result = validateArray(obj.ranges, 1, gridRangeValidatorInstance, '{GridRange}');
            if (!result.success) {
                result.error = "GridSubtreeFilter.ranges: " + result.error;
                return result;
            }
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'GridSubtreeFilter: Optional field "id" is wrong type' };
        }
        if (obj.ids !== undefined) {
            const result = validateArray(obj.ids, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridSubtreeFilter.ids: " + result.error;
                return result;
            }
        }
        if ((obj.itemType !== undefined) && (typeof obj.itemType !== 'string')) {
            return { success: false, error: 'GridSubtreeFilter: Optional field "itemType" is wrong type' };
        }
        if (obj.itemTypes !== undefined) {
            const result = validateArray(obj.itemTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridSubtreeFilter.itemTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GridSubtreeFilter.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GridSubtreeFilter"' };
        }
        return { success: true };
    }
}
export const gridSubtreeFilterValidatorInstance = new GridSubtreeFilterValidator();
export class GridRangeFilterValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridRangeFilter: Expected object, got undefined object for GridRangeFilterValidator' };
        }
        if ((obj.range !== undefined)) {
            const result = gridRangeValidatorInstance.validate(obj.range);
            if (!result.success) {
                result.error = "GridRangeFilter.range: " + result.error;
                return result;
            }
        }
        if ((obj.overlap !== undefined) && (typeof obj.overlap !== 'number')) {
            return { success: false, error: 'GridRangeFilter: Optional field "overlap" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'GridRangeFilter: Optional field "id" is wrong type' };
        }
        if (obj.ids !== undefined) {
            const result = validateArray(obj.ids, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridRangeFilter.ids: " + result.error;
                return result;
            }
        }
        if ((obj.itemType !== undefined) && (typeof obj.itemType !== 'string')) {
            return { success: false, error: 'GridRangeFilter: Optional field "itemType" is wrong type' };
        }
        if (obj.itemTypes !== undefined) {
            const result = validateArray(obj.itemTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridRangeFilter.itemTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GridRangeFilter.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GridRangeFilter"' };
        }
        return { success: true };
    }
}
export const gridRangeFilterValidatorInstance = new GridRangeFilterValidator();
export class GridRangeSampleFilterValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridRangeSampleFilter: Expected object, got undefined object for GridRangeSampleFilterValidator' };
        }
        if (obj.cellCountLimit === undefined) {
            return { success: false, error: 'GridRangeSampleFilter: Required field "cellCountLimit" is missing' };
        }
        else if (typeof obj.cellCountLimit !== 'number') {
            return { success: false, error: 'GridRangeSampleFilter: Required field "cellCountLimit" is wrong type' };
        }
        if (obj.headerFooterMargin === undefined) {
            return { success: false, error: 'GridRangeSampleFilter: Required field "headerFooterMargin" is missing' };
        }
        else if (typeof obj.headerFooterMargin !== 'number') {
            return { success: false, error: 'GridRangeSampleFilter: Required field "headerFooterMargin" is wrong type' };
        }
        if (obj.isColumnMajorScheme === undefined) {
            return { success: false, error: 'GridRangeSampleFilter: Required field "isColumnMajorScheme" is missing' };
        }
        else if (typeof obj.isColumnMajorScheme !== 'boolean') {
            return { success: false, error: 'GridRangeSampleFilter: Required field "isColumnMajorScheme" is wrong type' };
        }
        if ((obj.range !== undefined)) {
            const result = gridRangeValidatorInstance.validate(obj.range);
            if (!result.success) {
                result.error = "GridRangeSampleFilter.range: " + result.error;
                return result;
            }
        }
        if ((obj.overlap !== undefined) && (typeof obj.overlap !== 'number')) {
            return { success: false, error: 'GridRangeSampleFilter: Optional field "overlap" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'GridRangeSampleFilter: Optional field "id" is wrong type' };
        }
        if (obj.ids !== undefined) {
            const result = validateArray(obj.ids, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridRangeSampleFilter.ids: " + result.error;
                return result;
            }
        }
        if ((obj.itemType !== undefined) && (typeof obj.itemType !== 'string')) {
            return { success: false, error: 'GridRangeSampleFilter: Optional field "itemType" is wrong type' };
        }
        if (obj.itemTypes !== undefined) {
            const result = validateArray(obj.itemTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GridRangeSampleFilter.itemTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GridRangeSampleFilter.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GridRangeSampleFilter"' };
        }
        return { success: true };
    }
}
export const gridRangeSampleFilterValidatorInstance = new GridRangeSampleFilterValidator();
export class WorkflowModelItemBaseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowModelItemBase: Expected object, got undefined object for WorkflowModelItemBaseValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'WorkflowModelItemBase: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'WorkflowModelItemBase: Required field "id" is wrong type' };
        }
        if ((obj.operation !== undefined)) {
            const result = itemOperationValidatorInstance.validate(obj.operation);
            if (!result.success) {
                result.error = "WorkflowModelItemBase.operation: " + result.error;
                return result;
            }
        }
        if ((obj.delta !== undefined)) {
            const result = itemDeltaValidatorInstance.validate(obj.delta);
            if (!result.success) {
                result.error = "WorkflowModelItemBase.delta: " + result.error;
                return result;
            }
        }
        if (obj.deltas !== undefined) {
            const result = validateArray(obj.deltas, 1, itemDeltaValidatorInstance, '{ItemDelta}');
            if (!result.success) {
                result.error = "WorkflowModelItemBase.deltas: " + result.error;
                return result;
            }
        }
        if ((obj.isContext !== undefined) && (typeof obj.isContext !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItemBase: Optional field "isContext" is wrong type' };
        }
        if ((obj.asyncBoundary !== undefined) && (typeof obj.asyncBoundary !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItemBase: Optional field "asyncBoundary" is wrong type' };
        }
        if ((obj.schema !== undefined)) {
            const result = workflowModelItemSchemaValidatorInstance.validate(obj.schema);
            if (!result.success) {
                result.error = "WorkflowModelItemBase.schema: " + result.error;
                return result;
            }
        }
        if (obj.revId === undefined) {
            return { success: false, error: 'WorkflowModelItemBase: Required field "revId" is missing' };
        }
        else if (typeof obj.revId !== 'string') {
            return { success: false, error: 'WorkflowModelItemBase: Required field "revId" is wrong type' };
        }
        return { success: true };
    }
}
export const workflowModelItemBaseValidatorInstance = new WorkflowModelItemBaseValidator();
export class WorkflowModelItemValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowModelItem: Expected object, got undefined object for WorkflowModelItemValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'WorkflowModelItem: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'WorkflowModelItem: Required field "id" is wrong type' };
        }
        if ((obj.operation !== undefined)) {
            const result = itemOperationValidatorInstance.validate(obj.operation);
            if (!result.success) {
                result.error = "WorkflowModelItem.operation: " + result.error;
                return result;
            }
        }
        if ((obj.delta !== undefined)) {
            const result = itemDeltaValidatorInstance.validate(obj.delta);
            if (!result.success) {
                result.error = "WorkflowModelItem.delta: " + result.error;
                return result;
            }
        }
        if (obj.deltas !== undefined) {
            const result = validateArray(obj.deltas, 1, itemDeltaValidatorInstance, '{ItemDelta}');
            if (!result.success) {
                result.error = "WorkflowModelItem.deltas: " + result.error;
                return result;
            }
        }
        if ((obj.isContext !== undefined) && (typeof obj.isContext !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItem: Optional field "isContext" is wrong type' };
        }
        if ((obj.asyncBoundary !== undefined) && (typeof obj.asyncBoundary !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItem: Optional field "asyncBoundary" is wrong type' };
        }
        if ((obj.schema !== undefined)) {
            const result = workflowModelItemSchemaValidatorInstance.validate(obj.schema);
            if (!result.success) {
                result.error = "WorkflowModelItem.schema: " + result.error;
                return result;
            }
        }
        if (obj.revId === undefined) {
            return { success: false, error: 'WorkflowModelItem: Required field "revId" is missing' };
        }
        else if (typeof obj.revId !== 'string') {
            return { success: false, error: 'WorkflowModelItem: Required field "revId" is wrong type' };
        }
        return { success: true };
    }
}
export const workflowModelItemValidatorInstance = new WorkflowModelItemValidator();
export class WorkflowModelValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowModel: Expected object, got undefined object for WorkflowModelValidator' };
        }
        if (obj.scopeItem === undefined) {
            return { success: false, error: 'WorkflowModel: Required field "scopeItem" is missing' };
        }
        else {
            const result = workflowModelItemValidatorInstance.validate(obj.scopeItem);
            if (!result.success) {
                result.error = "WorkflowModel.scopeItem: " + result.error;
                return result;
            }
        }
        if (obj.rootItem === undefined) {
            return { success: false, error: 'WorkflowModel: Required field "rootItem" is missing' };
        }
        else {
            const result = workflowModelItemValidatorInstance.validate(obj.rootItem);
            if (!result.success) {
                result.error = "WorkflowModel.rootItem: " + result.error;
                return result;
            }
        }
        if ((obj.sourceInfo !== undefined)) {
            const result = sourceInfoValidatorInstance.validate(obj.sourceInfo);
            if (!result.success) {
                result.error = "WorkflowModel.sourceInfo: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const workflowModelValidatorInstance = new WorkflowModelValidator();
//# sourceMappingURL=workflow-model-validator.g.js.map